<template>
  <div>
    <div class="common-form">
      <span>{{ curItem.name }}</span>
    </div>
    <el-form size="small" :model="curItem" label-width="60px">

      <el-form-item label="分类：">
        <div v-for="(item, index) in curItem.data" :key="index + '_p'" class="border p-10 m-v-10">
          <div class="param-img-item">
            <div class="delete-box">
              <i class="el-icon-delete-solid" @click="$parent.onEditorDeleleData(index, selectedIndex)"></i>
            </div>
            <div class="url-box1">
              <span class="key-name">分类名称：</span>
              <el-input v-model="item.categoryName"></el-input>
            </div>
          </div>
          <div class="param-img-item d-s-s d-r" :key="index" v-for="(navBar, index) in item.list">
            <div class="delete-box">
              <i class="el-icon-delete-solid" @click="onListDel(item.list,index)"></i>
            </div>
            <div class="d-c-c d-c">
              <div class="icon">
                <img style="width: 80px;height: 80px" v-img-url="navBar.imgUrl" alt=""
                     @click="$parent.onEditorSelectImage(navBar, 'imgUrl')">
              </div>
            </div>

            <div class="ml30" style="width: 60%">
              <div class="url-box1">
                <span class="key-name">文字内容：</span>
                <el-input v-model="navBar.text"></el-input>
              </div>
              <div class="d-s-c margin-top-5">
                <div class="url-box flex-1">
                  <span class="key-name">链接名称：</span>
                  <el-input v-model="navBar.name"></el-input>
                </div>
                <div class="url-box ml10">
                  <el-button type="primary" @click="changeLink(navBar)">选择链接</el-button>
                </div>
              </div>
            </div>
          </div>
          <div class="d-c-c">
            <el-button @click="onItemAdd(item.list)">添加一个</el-button>
          </div>
        </div>
        <div class="d-c-c">
          <el-button @click="$parent.onEditorAddData">添加分类</el-button>
        </div>
      </el-form-item>
    </el-form>
    <Setlink v-if="is_linkset" :is_linkset="is_linkset" @closeDialog="closeLinkset">选择链接</Setlink>
  </div>
</template>

<script>
import Setlink from '@/components/setlink/Setlink'
import {deepClone} from '@/utils/base.js'

export default {
  name: 'Category',
  components: {
    Setlink,
  },
  props: ['curItem', 'selectedIndex', 'opts'],
  data () {
    return {
      /*是否选择链接*/
      is_linkset: false,
      navBar: null,
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },

    /*选择链接*/
    changeLink (navBar) {
      this.is_linkset = true
      this.navBar = navBar
    },

    /*获取链接并关闭弹窗*/
    closeLinkset (e) {
      this.is_linkset = false
      if (e) {
        this.navBar.linkUrl = e.url
        this.navBar.name = '链接到' + ' ' + e.type + ' ' + e.name
      }
    },
    onListDel (list, index) {
      if (list.length <= 1) {
        this.$message({
          message: '至少保留一个',
          type: 'error'
        })
        return false
      }
      list.splice(index, 1)
    },
    onItemAdd (list) {
      var newDataItem = deepClone(list[0])
      list.push(newDataItem)
    },
  }
}
</script>

<style lang="scss" scoped>
.param-img-item .url-box1 .el-input {
  width: 40%;
  /*flex: 1;*/
}

.param-img-item .url-box1 {
  display: flex;
  justify-content: flex-start;
  line-height: 40px;
}

.param-img-item .url-box1 .key-name {
  display: block;
  width: 80px;
}
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/params/Category.vue